import ComponentHeader from '../ComponentHeader';
import StyledWrapper from '../style';

import { getElementIcon } from '../../../FormBuilder/utils';
import {
	FormControl,
	FormControlLabel,
	FormGroup,
	Tooltip,
	Checkbox,
	FormHelperText
} from '@mui/material';

const Checkboxes = (props) => {
	const { data, style, disabled } = props;

	let classNames = 'custom-control custom-checkbox';
	if (data.inline) {
		classNames += ' option-inline';
	}

	let baseClasses = 'SortableItem rfb-item';
	if (data.pageBreakBefore) {
		baseClasses += ' alwaysbreak';
	}

	const label = data?.label && data?.label !== ' ' ? data?.label : data?.text;
	const isFormBuilder = true;

	return (
		<div style={{ ...style }} className={baseClasses}>
			<ComponentHeader {...props} />
			<>
				<div className="inner-form-group">
					<FormControl sx={{ width: '100%' }} variant="outlined">
						<StyledWrapper.CustomLabel
							disabled={disabled ? true : false}
							required={data?.required}
							shrink={true}
							className={''}
						>
							<>
								{isFormBuilder && getElementIcon(data?.key)}
								<Tooltip
									title={`${label}${
										isFormBuilder
											? data?.unique_identifier
												? ` (ff-${data?.unique_identifier})`
												: `(temp-${data?.temp_order})`
											: ''
									}`}
									placement="top"
								>
									<p>
										{`${label}${
											isFormBuilder
												? data?.unique_identifier
													? ` (ff-${data?.unique_identifier})`
													: `(temp-${data?.temp_order})`
												: ''
										}`}
									</p>
								</Tooltip>
							</>
						</StyledWrapper.CustomLabel>
						<StyledWrapper.BorderOutline
							className={'customInputOutline'}
							disabled={disabled ? true : false}
						>
							<FormGroup>
								<div
									style={{
										display: 'flex',
										flexDirection: `${data?.inline ? 'row' : 'column'}`,
										flexWrap: 'wrap'
									}}
								>
									{data?.options.map((option) => {
										const this_key = `preview_${option.key}`;
										const checkboxProps = {
											name: `option_${option.key}`,
											type: 'checkbox',
											value: option.key
										};

										return (
											<div key={this_key}>
												<FormControlLabel
													className="disableWhiteBackground"
													disabled={disabled}
													control={
														<Checkbox
															id={`fid_${this_key}`}
															{...checkboxProps}
															disabled={disabled}
															inputProps={{
																'data-value': option?.value
															}}
														/>
													}
													label={option?.text}
												/>
											</div>
										);
									})}
								</div>
							</FormGroup>
						</StyledWrapper.BorderOutline>
					</FormControl>
				</div>
				<FormHelperText error={data?.error}>{data?.help_message || ''}</FormHelperText>
			</>
		</div>
	);
};

export default Checkboxes;
